const oauth2Links = {
  root: () => '/oauth2',
  login: () => '/oauth2/login',
  consent: () => '/oauth2/consent',
};

export default oauth2Links;
